var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.VALUE == '3')?_c('Icon',{attrs:{"icon":"material-symbols:check-circle","color":"#28c76f","width":"25","height":"25"}}):(_vm.VALUE == null)?_c('div',{attrs:{"color":"danger"}}):_c('Icon',{attrs:{"icon":"material-symbols:check-circle","color":"#EA5455","width":"25","height":"25"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }